import { SliceCaseReducers } from '@reduxjs/toolkit'
import { createOperationSlice, GenericOperationState } from '@repo/core'
import { OtpRequiredResponse, RecoverPasswordPayload } from '@repo/user-types'

const initialState: GenericOperationState<OtpRequiredResponse | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: recoverPasswordActions, reducer: recoverPasswordReducer } =
  createOperationSlice<
    OtpRequiredResponse | null,
    SliceCaseReducers<GenericOperationState<OtpRequiredResponse | null>>,
    RecoverPasswordPayload
  >({
    name: '@users/security/recoverPassword',
    initialState,
    reducers: {},
  })
